
import { CSSProperties, ReactNode } from 'react';
import styles from './Content.module.scss'
interface ContentProps {
  title?: string;
  textLeft?: string;
  textRight?: string;
  textLeftSmall?: string;
  textRightBig?: string;
  bgImage?: string;
  titleBig?: string;
  image?: string;
  orderReverse?: string;
  iframe?: string;
  link?: ReactNode;
}
const Content: React.FC<ContentProps> = ({ title, textLeft, textRight, bgImage, textLeftSmall, textRightBig, titleBig, image, iframe, orderReverse, link }) => {
  const sectionStyles: Pick<CSSProperties, 'backgroundImage' | 'background'> =
    {}
  if (bgImage) {
    sectionStyles['backgroundImage']
  }
  return (
    <section className={styles.content}>

      <div className='container'>
        {title && (
          <div className='row'>
            <div className='col-12  col-xl-6 px-4' dangerouslySetInnerHTML={{ __html: title }} />
          </div>
        )}
        {titleBig && (
          <div className='row'>
            <div className='col-12  col-xl-10 px-4' dangerouslySetInnerHTML={{ __html: titleBig }} />
          </div>
        )}
        <div className={`row ${bgImage ? styles.bgStyles : ''}`} style={{ backgroundImage: bgImage }}>
          {textLeft && <div className={`col-12 col-xl-6 px-4 order-1 order-${orderReverse}`} >
            <div dangerouslySetInnerHTML={{ __html: textLeft }} />

          </div>}
          {image &&
            <div className='col-12 col-xl-6 px-4'>
              <img className='img-fluid' src={image} alt="" />
            </div>
          }
          {iframe &&
            <div className='col-12 col-xl-6 px-4'>
              <iframe src={iframe} frameBorder="0"></iframe>
            </div>
          }

          {textRight && <div className={`col-12 col-xl-6 px-4 order-1 order-${orderReverse} `} >
            <div dangerouslySetInnerHTML={{ __html: textRight }} />
            {link && link}
          </div>}


          {textLeftSmall && <div className='col-12 col-xl-3 px-4 ' >
            <div dangerouslySetInnerHTML={{ __html: textLeftSmall }} />
            {link && link}
          </div>}

          {textRightBig && <div className='col-12 col-xl-9 px-4' >
            <div dangerouslySetInnerHTML={{ __html: textRightBig }} />
            {link && link}
          </div>}
        </div>
      </div>

    </section>
  )
}
export default Content;